/** @typedef {"bankTransfer" | "creditCard"} PaymentMethod */

export const PaymentMethod = {
  BANK_TRANSFER: "bankTransfer",
  CREDIT_CARD: "creditCard",
};
